import template from './item_type.html';
import controller from './item_type.controller';
import './item_type.scss';

let itemTypeComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template,
  controller
};

export default itemTypeComponent;


// WEBPACK FOOTER //
// ./client/app/components/item_type/item_type.component.js